/* eslint-disable react/no-unstable-nested-components */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Assets
import { SentIcon } from 'assets/images/Icons'

// Styled Elements
import {
  TableButtonWrapper,
  TableRowWrapper,
  TableColWrapper,
  TableRowContainer,
  TableText,
  TableSubText,
} from './DemoTravelRuleTableItem.elements'

// Views
import { AccordionTableItem, ProgressBar, SkeletonText } from 'views/components'
import DemoTravelRuleTableItemDetails from '../DemoTravelRuleTableItemDetails'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = (dispatch) => actions(dispatch)

function DemoTravelRuleTableItem(props) {
  // Destructure
  const { progress } = props
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <AccordionTableItem
      setIsExpanded={setIsExpanded}
      expandPanel={isExpanded}
      button={
        <TableButtonWrapper>
          <TableRowWrapper isExpanded={false}>
            <TableRowContainer>
              <SentIcon size={18} />
              <TableColWrapper>
                <TableText>
                  <SkeletonText width="160" />
                </TableText>
                <TableSubText>
                  Sent | <SkeletonText height="10" width="90" borderRadius="3" />
                </TableSubText>
              </TableColWrapper>
            </TableRowContainer>

            <TableRowContainer>
              <SkeletonText width="140" />
            </TableRowContainer>
          </TableRowWrapper>

          <TableRowWrapper isExpanded={false}>
            <TableRowContainer>
              <SkeletonText width="70" />
              <ProgressBar width={progress || '20%'} />
            </TableRowContainer>

            <TableRowContainer>
              <TableColWrapper>
                <SkeletonText width="60" />
                <SkeletonText width="80" height="10" borderRadius="3" style={{ marginTop: 2 }} />
              </TableColWrapper>
            </TableRowContainer>
          </TableRowWrapper>
        </TableButtonWrapper>
      }
      panel={<DemoTravelRuleTableItemDetails />}
    />
  )
}

// Default Props
DemoTravelRuleTableItem.defaultProps = {
  actions: {},
  progress: '',
}

// Proptypes Validation
DemoTravelRuleTableItem.propTypes = {
  actions: PropTypes.shape({
    toggleUpgradeModal: PropTypes.func,
    setInfoModalDetails: PropTypes.func,
  }),
  progress: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(DemoTravelRuleTableItem)
